import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ConditionChoice } from './PartsShipmentsHelpers';
import { NSPartLocationList } from '../../../../../@types/part.type';

export interface StockConditionPickerProps {
  choice: ConditionChoice;
  onChoose: (row: NSPartLocationList) => void;
  onDismiss: () => void;
}

// Shown when a consumable part type is held at the source in more than one
// stock condition — each manifest line dispatches from a single NSPart
// record, so the user must pick which condition to draw from.
export const StockConditionPicker: React.FC<StockConditionPickerProps> = ({
  choice,
  onChoose,
  onDismiss,
}) => (
  <Box
    role="group"
    aria-label={`Select stock condition for ${choice.partTypeName}`}
    sx={{
      border: '1px solid',
      borderColor: 'v4.borderDark',
      borderRadius: 1,
      p: 1.5,
      mb: 1,
      bgcolor: 'v4.background',
    }}
  >
    <Typography sx={{ fontSize: '12px', fontWeight: 600, mb: 0.5 }}>
      {choice.partTypeName} is held in multiple conditions — select the stock to dispatch
    </Typography>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
      {choice.rows.map((row) => (
        <Button
          key={row.id}
          size="small"
          variant="outlined"
          onClick={() => onChoose(row)}
          sx={{ fontSize: '11px', textTransform: 'none' }}
        >
          {row.condition || row.conditionCode || 'Unknown'} — {row.quantity ?? 0} available
        </Button>
      ))}
      <Button
        size="small"
        onClick={onDismiss}
        sx={{ fontSize: '11px', textTransform: 'none', color: 'text.secondary' }}
      >
        Cancel
      </Button>
    </Box>
  </Box>
);
